// 新的请求封装
import axios from "axios";
import api from "@/utils/api";
axios.defaults.timeout = 200000;
import { wxLogin } from "@/utils/common";
import { Toast, Dialog } from "vant";
//http request 拦截器
axios.interceptors.request.use(
  config => {
    config.data = config.data;
    if(config.url.indexOf('https://apis.map.qq.com/ws/geocoder/v1') == -1) {
      config.headers = {
        "Content-Type": "application/json"
      };
    }else {
      config.headers = {
        'Content-Type': 'application/json',
      }
    }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);

//http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

function get(url, params = {}) {
  Toast.loading({
    message: "加载中",
    forbidClick: true
  });
  return new Promise((resolve, reject) => {
    axios
      .get(api.baseUrl + url, {
        params: params
      })
      .then(response => {
        Toast.clear();
        if (response.data.sta == -500) {
          // token 实现了，需要重新执行一次登录操作
          wxLogin();
          return;
        } else if (response.data.sta == 0) {
          // 接口请求正常
          resolve(response.data);
        } else {
          if (response.data.sta == -1 && response.data.errcode == 808) {
            // 接口报错了
            reject(response);
            return;
          }
          if (
            response.data.msg &&
            response.data.msg.indexOf("参与人数已达上限") > -1
          ) {
            Dialog({
              title: "温馨提示",
              message: "签到参与人数已达到上限，请联系管理员"
            });
            return;
          }
          if (
            response.data.msg &&
            response.data.msg.indexOf("No JSON object could be decoded") > -1
          ) {
            // 解析失败
            reject(response);
            return;
          }
          Dialog({
            title: "温馨提示",
            message: response.data.msg
          });
          reject(response);
        }
      })
      .catch(err => {
        Toast.clear();
        Dialog({
          title: "温馨提示",
          message: "网络异常，请检查网络后重试"
        });
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

function post(url, data = {}, is_upload = false) {
  Toast.loading({
    message: "加载中",
    forbidClick: true
  });
  return new Promise((resolve, reject) => {
    axios
      .post(
        api.baseUrl + url,
        data,
        is_upload
          ? { headers: { "Content-Type": "multipart/form-data" } }
          : { headers: { "Content-Type": "application/json" } }
      )
      .then(
        response => {
          Toast.clear();
          if (response.data.sta == -500) {
            // token 实现了，需要重新执行一次登录操作
            wxLogin();
            return;
          } else if (response.data.sta == 0) {
            // 接口请求正常
            resolve(response.data);
          } else {
            if (response.data.sta == -1 && response.data.errcode == 808) {
              // 接口报错了
              reject(response);
              return;
            }
            if (
              response.data.msg &&
              response.data.msg.indexOf("参与人数已达上限") > -1
            ) {
              Dialog({
                title: "温馨提示",
                message: "签到参与人数已达到上限，请联系管理员"
              });
              return;
            }
            if (
              response.data.msg &&
              response.data.msg.indexOf("No JSON object could be decoded") > -1
            ) {
              // 解析失败
              reject(response);
              return;
            }
            Dialog({
              title: "温馨提示",
              message: response.data.msg
            });
            reject(response);
          }
        },
        err => {
          Toast.clear();
          Dialog({
            title: "温馨提示",
            message: "网络异常，请检查网络后重试"
          });
        }
      );
  });
}

function getAddressInfo(latitude, longitude) {
  Toast.loading({
    message: "加载中",
    forbidClick: true
  });
  return new Promise((resolve, reject) => {
    // 使用 fetch
    fetch(`https://apis.map.qq.com/ws/geocoder/v1?location=${latitude},${longitude}&key=V53BZ-DRXLX-4HF4Y-7BVDU-YIHJH-PXBGK&get_poi=0`, {
      method:'GET',
      headers:{
        "Content-Type": "application/json"
      },
      mode:'cors'
    })
    .then(response =>{
      if(response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      }else {
        return Promise.reject(new Error(response))
      }
    })
    .then(response=>{
      return response.json()
    })
    .then(response=>{
      Toast.clear();
      if (response.status == 0) {
        resolve(response);
      } else {
        Dialog({
          title: "温馨提示",
          message: "网络异常，请稍后重试"
        });
        reject(response);
      }
    }).catch(err=>{
      Toast.clear();
        Dialog({
          title: "温馨提示",
          message: "网络异常，请检查网络后重试" + JSON.stringify(err)
        });
    })

    // axios({
    //   method: "GET",
    //   url: "https://apis.map.qq.com/ws/geocoder/v1",
    //   params: {
    //     location: latitude + "," + longitude,
    //     key: "V53BZ-DRXLX-4HF4Y-7BVDU-YIHJH-PXBGK",
    //     get_poi: 0
    //   }
    // })
    //   .then(response => {
    //     Toast.clear();
    //     if (response.data.status == 0) {
    //       resolve(response.data);
    //     } else {
    //       Dialog({
    //         title: "温馨提示",
    //         message: "网络异常，请稍后重试"
    //       });
    //       reject(response.data);
    //     }
    //   })
    //   .catch(err => {
    //     Toast.clear();
    //     Dialog({
    //       title: "温馨提示",
    //       message: "网络异常，请检查网络后重试" + JSON.stringify(err)
    //     });
    //   });
  });
}

export default {
  get,
  post,
  getAddressInfo
};



// WEBPACK FOOTER //
// ./src/utils/http.js